import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { audioApi } from "./api";
import { log } from "../lib/log";

const AudioAuthCtx = createContext({ user: null, subscribed: false, loading: true, refresh: () => {}, logout: () => {} });

export function AudioAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [subscribed, setSubscribed] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await audioApi.get("/auth/me");
      setUser(data.user);
      setSubscribed(!!data.subscribed);
      setSubscription(data.subscription || null);
    } catch (err) {
      if (err?.response?.status !== 401) {
        log.warn("[audio-auth] /auth/me failed:", err?.message || err);
      }
      setUser(null); setSubscribed(false); setSubscription(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = useCallback(async () => {
    try { await audioApi.post("/auth/logout"); }
    catch (err) { log.warn("[audio-auth] logout failed:", err?.message || err); }
    setUser(null); setSubscribed(false); setSubscription(null);
  }, []);

  const value = useMemo(
    () => ({ user, subscribed, subscription, loading, refresh, logout }),
    [user, subscribed, subscription, loading, refresh, logout],
  );

  return <AudioAuthCtx.Provider value={value}>{children}</AudioAuthCtx.Provider>;
}

export const useAudioAuth = () => useContext(AudioAuthCtx);
